import React from 'react';
import { useSelector } from 'react-redux';
import IAMSAForm from './IAMSAForm';
import GfaForm from './GfaForm';
import SNForm from './SNForm';
import CDSForm from './CDSForm';

const components = {
  'gfa': GfaForm,
  'roll-bits': GfaForm,
  'satelitenorte': SNForm,
  'saritur': SNForm,
  'empresaunida': SNForm,
  'expressosaoluiz': SNForm,
  'rochoa': SNForm,
  'cds': CDSForm,
  'default': IAMSAForm,
};

const FormLayout = (props) => {
  const { env } = useSelector((state) => state.whitelabelConfig);
  const Component = components[env.brand] ?? components.default;

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component {...props} />;
};

export default FormLayout;
